import React, { useEffect, useState } from "react";
import Menu from "../../components/Menu";
import { useNavigate } from "react-router-dom";
import api from "../../apiFormData";
import Swal from "sweetalert2";

import "./Partners.css";
import InputImage from "../../components/InputImage";
import InputCPFCNPJ from "../../components/InputCPFCNPJ";
import InputPhone from "../../components/InputPhone";
import InputPhoneMobile from "../../components/InputPhoneMobile";
import InputDate from "../../components/InputDate";
import Validations from "../../Validations";
import LoadingBlock from "../../components/LoadingBlock";
import Avatar from "../../assets/img/hospital.svg";
import FooterAdd from "../../components/FooterAdd";
import ProcedimentosModal from "../../components/modals/ProcedimentosModal.js";
//api/procedures/list

function PartnersAdd() {
  const FIXED_ID_SHOPPER = 14;
  const [teste, setTeste] = useState(0);
  const [parceiroId, setParceiroId] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [error, setError] = useState({});
  const [name, setName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState("");
  const [urlAccess, setUrlAccess] = useState("");
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [phone, setPhone] = useState("");
  const [status, setStatus] = useState("");
  const [phoneMobile, setPhoneMobile] = useState("");
  const [teleconsultation, setTeleconsultation] = useState(null);
  const [isPartner, setIsPartner] = useState(null);
  const [accessApp, setAccessApp] = useState(null);

  const [contract, setContract] = useState("");
  const [contractDate, setContractDate] = useState("");
  const [contractExpiration, setContractExpiration] = useState("");
  const [packageClient, setPackageClient] = useState("");

  const [proceduresPartners, setProceduresPartners] = useState([]);
  const [loadingPartners, setLoadingPartners] = useState(true);
  const [errorPartners, setErrorPartners] = useState(null);

  const [image, setImage] = useState({
    fileReal: "",
    file: "",
  });

  const onSubmit = (ev) => {
    ev.preventDefault();
    var cpfCnpjClear = cpfCnpj
      .replaceAll("/", "")
      .replaceAll(".", "")
      .replaceAll("-", "");
    var errors = {
      name: name.replaceAll(" ", "") === "" ? true : false,
      companyName: companyName.replaceAll(" ", "") === "" ? true : false,
      address: address.replaceAll(" ", "") === "" ? true : false,
      email: !Validations.emailValid(email),
      cpfCnpj: !(cpfCnpjClear.length < 12
        ? Validations.CPFValid(cpfCnpj)
        : Validations.CNPJValid(cpfCnpj)),
      location: location === "" ? true : false,
      phone: !Validations.PhoneValid(phone),
      mobile: !Validations.PhoneMobile(phoneMobile),
      status: status === "" ? true : false,
      contractDate: Validations.DateDDMMAAAAInvalid(contractDate),
      contractExpiration: Validations.DateDDMMAAAAInvalid(contractExpiration),
      contract: contract === "" ? true : false,
      accessUrl: urlAccess === "" ? true : false,
      teleconsultation: teleconsultation === null ? true : false,
      accessApp: accessApp === null ? true : false,
    };
    setError(errors);
    var validations = true;

    for (const key in errors) {
      if (errors.hasOwnProperty(key) && errors[key] === true) {
        validations = false;
      }
    }

    if (validations) {
      var form = new FormData();
      image.fileReal !== ""
        ? form.set("image", image.fileReal)
        : console.log("");
      form.set("name", name);
      form.set("company_name", companyName);
      form.set("email", email);
      form.set("type", cpfCnpjClear.length < 12 ? 0 : 1);
      form.set("cnpj_cpf", cpfCnpjClear);
      form.set("address_info", address);
      form.set("location", location);
      form.set("contract_number", contract);
      form.set(
        "phone",
        phone
          .replaceAll(" ", "")
          .replaceAll("(", "")
          .replaceAll(")", "")
          .replaceAll("-", "")
      );
      form.set(
        "mobile",
        phoneMobile
          .replaceAll(" ", "")
          .replaceAll("(", "")
          .replaceAll(")", "")
          .replaceAll("-", "")
      );
      form.set(
        "contract_date",
        contractDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3$2$1")
      );
      form.set(
        "contract_valid",
        contractExpiration.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3$2$1")
      );
      form.set("status", parseInt(status, 10));
      form.set("access_url", urlAccess);
      form.set("location", location);
      form.set("package_id", packageClient);

      setLoading(true);

      api
        .post("/api/affiliatecompanies", form)
        .then((response) => {
          console.log(response);
          if (response.data && response.data.id) {
            setParceiroId(response.data.id);

            // Agora que o parceiroId está disponível, você pode fazer o segundo POST
            api
              .post("/api/affiliatecompany/add/shopper/relationship", {
                shopper_id: FIXED_ID_SHOPPER,
                affiliate_company_id: response.data.id, // Use o id diretamente da resposta
              })
              .then((response) => {
                Swal.fire({
                  title: "Parceiro cadastrado com sucesso!",
                  text: "Deseja cadastrar procedimentos para este parceiro?",
                  icon: "success",
                  showCancelButton: true,
                  confirmButtonText: "Sim",
                  cancelButtonText: "Não",
                  confirmButtonColor: "#3c8dbc",
                  cancelButtonColor: "#d33",
                }).then((result) => {
                  if (result.isConfirmed) {
                    setProceduresPartners(proceduresPartners);
                    setLoadingPartners(loadingPartners);
                    setErrorPartners(errorPartners);
                    openModal(); // Abre o modal de cadastro de procedimentos
                  }
                });
              })
              .catch((error) => {
                console.error(error);
                Swal.fire({
                  title: "Erro ao associar shopper",
                  text: error.message,
                  icon: "error",
                  confirmButtonColor: "#3c8dbc",
                });
              });

            Swal.fire({
              title: "Parceiro cadastrado com sucesso",
              icon: "success",
              confirmButtonColor: "#3c8dbc",
            });
          } else {
            Swal.fire({
              title: "Erro",
              text: "A resposta da API não contém os dados esperados.",
              icon: "error",
              confirmButtonColor: "#3c8dbc",
            });
          }
        })
        .catch((error) => {
          console.error(error);
          Swal.fire({
            title: "Cliente não cadastrado",
            text: error.message,
            icon: "error",
            confirmButtonColor: "#3c8dbc",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  const screenTela = (
    <>
      {loading && <LoadingBlock />}
      <form onSubmit={onSubmit}>
        <div className="screenContainer edit-mode">
          <div className="my-header-partner">
            <h1>Parceiro </h1>
            <label>ACHEMED</label>
          </div>
          <div className="row">
            <h4>Dados Básicos</h4>

            <div className="d-flex justify-content-center col-12 col-sm-4 col-lg-4">
              <InputImage
                imageAvatar={Avatar}
                image={image}
                setImage={setImage}
              />
            </div>
            <div
              className="col-12 col-sm-4 col-lg-4 row"
              style={{ padding: "0px", margin: "-1px" }}>
              <div className="col-12">
                <label className="form-label-input">Nome*</label>
                <input
                  className="form-control"
                  value={name}
                  type="text"
                  name="name"
                  placeholder="Nome"
                  onChange={(value) =>
                    setName(value.target.value.toUpperCase())
                  }
                />
                {error.name && <span className="error">Campo Inválido</span>}
              </div>
              <div className="col-12">
                <label className="form-label-input">Email*</label>
                <input
                  className="form-control"
                  value={email}
                  onChange={(value) => setEmail(value.target.value)}
                  type="text"
                  name="email"
                  placeholder="Email"
                />
                {error.email && <span className="error">Campo Inválido</span>}
              </div>
              <div className="col-12">
                <label className="form-label-input">CPF/CNPJ*</label>
                <InputCPFCNPJ value={cpfCnpj} onChange={setCpfCnpj} />
                {error.cpfCnpj && <span className="error">Campo Inválido</span>}
              </div>
            </div>
            <div
              className="col-12 col-sm-4 col-lg-4 row"
              style={{ padding: "0px", margin: "-1px" }}>
              <div className="col-12">
                <label className="form-label-input">Nome da Empresa*</label>
                <input
                  className="form-control"
                  value={companyName}
                  type="text"
                  name=""
                  placeholder="Nome da Empresa"
                  onChange={(value) =>
                    setCompanyName(value.target.value.toUpperCase())
                  }
                />
                {error.companyName && (
                  <span className="error">Campo Inválido</span>
                )}
              </div>
              <div className="col-12">
                <label className="form-label-input">Endereço*</label>
                <input
                  className="form-control"
                  value={address}
                  onChange={(value) =>
                    setAddress(value.target.value.toUpperCase())
                  }
                  type="text"
                  name="address_info"
                  placeholder="Endereço"
                />
                {error.address && <span className="error">Campo Inválido</span>}
              </div>
              <div className="col-12 ">
                <label className="form-label-input">Status*</label>
                <select
                  name="status"
                  value={status}
                  className="form-select"
                  onChange={(value) => setStatus(value.target.value)}>
                  <option value="" disabled>
                    Selecione um Status
                  </option>
                  <option value="0">Normal</option>
                  <option value="1">Suspenso</option>
                  <option value="2">Cancelado</option>
                  <option value="3">Pendente</option>
                </select>
                {error.status && <span className="error">Campo Inválido</span>}
              </div>
            </div>
          </div>
          <div className="row row-mod-hei">
            <div className="col-12 col-sm-4">
              <label className="form-label-input">Telefone*</label>
              <InputPhone value={phone} onChange={setPhone} />
              {error.phone && <span className="error">Campo Inválido</span>}
            </div>
            <div className="col-12 col-sm-4">
              <label className="form-label-input">Celular*</label>
              <InputPhoneMobile value={phoneMobile} onChange={setPhoneMobile} />
              {error.mobile && <span className="error">Campo Inválido</span>}
            </div>
            <div className="col-12 col-sm-4">
              <label className="form-label-input">URL de Acesso*</label>
              <input
                className="form-control"
                value={urlAccess}
                onChange={(value) => setUrlAccess(value.target.value)}
                type="text"
                name="access_url"
                placeholder="URl de Acesso"
              />
              {error.accessUrl && <span className="error">Campo Inválido</span>}
            </div>
          </div>
          <div className="row row-mod-hei">
            <div className="col-12 col-sm-4">
              <label className="form-label-input">Localização</label>
              <input
                className="form-control"
                value={location}
                onChange={(value) => setLocation(value.target.value)}
                type="text"
                name="location"
                placeholder="Localização"
              />
            </div>

            <div className="col-12 col-sm-4" style={{ paddingTop: 6 }}>
              <label className="form-label-input">Telemedicina*</label>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    onChange={() => {
                      setTeleconsultation(true);
                    }}
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    value={
                      teleconsultation === null && teleconsultation !== false
                        ? false
                        : teleconsultation
                    }
                  />
                  <label className="form-check-label" htmlFor="inlineRadio2">
                    Ativa
                  </label>
                </div>

                <div className="form-check form-check-inline">
                  <input
                    onChange={() => {
                      setTeleconsultation(false);
                    }}
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    value={
                      teleconsultation === null && teleconsultation !== true
                        ? false
                        : true
                    }
                  />
                  <label className="form-check-label" htmlFor="inlineRadio1">
                    Desativada
                  </label>
                </div>
              </div>

              {error.teleconsultation && (
                <span className="error">Campo Inválido</span>
              )}
            </div>

            <div style={{ paddingTop: 6 }} className="col-12 col-sm-4">
              <label className="form-label-input">App*</label>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    onChange={() => {
                      setAccessApp(true);
                    }}
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptionsApp"
                    id="inlineRadioApp2"
                    value={
                      accessApp === null && accessApp !== false
                        ? false
                        : accessApp
                    }
                  />
                  <label className="form-check-label" htmlFor="inlineRadioApp2">
                    Ativa
                  </label>
                </div>

                <div className="form-check form-check-inline">
                  <input
                    onChange={() => {
                      setAccessApp(false);
                    }}
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptionsApp"
                    id="inlineRadioApp1"
                    value={
                      accessApp === null && accessApp !== true ? false : true
                    }
                  />
                  <label className="form-check-label" htmlFor="inlineRadioApp1">
                    Desativada
                  </label>
                </div>
              </div>

              {error.accessApp && <span className="error">Campo Inválido</span>}
            </div>
          </div>
          <div className="row row-mod-hei">
            <h4>Dados de Contrato</h4>
            <div className="col-12 col-sm-4">
              <label className="form-label-input">Contrato*</label>
              <input
                className="form-control"
                value={contract}
                onChange={(value) => {
                  var inputValue = value.target.value.replace(/[a-zA-Z]/g, "");
                  setContract(inputValue);
                }}
                type="text"
                name="contract_number"
                placeholder="Contrato"
              />
              {error.contract && <span className="error">Campo Inválido</span>}
            </div>
            <div className="col-12 col-sm-4">
              <label className="form-label-input">Data do Contrato*</label>
              <InputDate value={contractDate} onChange={setContractDate} />
              {error.contractDate && (
                <span className="error">Campo Inválido</span>
              )}
            </div>
            <div className="col-12 col-sm-4">
              <label className="form-label-input">
                Vencimento do Contrato*
              </label>
              <InputDate
                value={contractExpiration}
                onChange={setContractExpiration}
              />
              {error.contractExpiration && (
                <span className="error">Campo Inválido</span>
              )}
            </div>
          </div>
          <div className="row row-mod-hei">
            <div className="col-12 col-sm-4">
              <label className="form-label-input">Pacote</label>
              <select
                name="status"
                value={packageClient}
                className="form-select"
                onChange={(value) => setPackageClient(value.target.value)}>
                <option value="" disabled>
                  Selecione um Pacote
                </option>
                <option value="1">Bronze</option>
                <option value="2">Prata</option>
                <option value="3">Ouro</option>
              </select>
            </div>
            <div className="col-12 col-sm-4">
              <label className="form-label-input">Parceiro*</label>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    onChange={() => {
                      setIsPartner(true);
                    }}
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio3"
                    value={
                      isPartner === null && isPartner !== true
                        ? false
                        : isPartner
                    }
                  />
                  <label className="form-check-label" htmlFor="inlineRadio3">
                    Sim
                  </label>
                </div>

                <div className="form-check form-check-inline">
                  <input
                    onChange={() => {
                      setIsPartner(false);
                    }}
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio4"
                    value={
                      isPartner === null && isPartner !== true ? false : true
                    }
                  />
                  <label className="form-check-label" htmlFor="inlineRadio4">
                    Não
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div>
            {/*Abrir o modal quando o botão for clicado */}
            {parceiroId && (
              <ProcedimentosModal
                isModalOpen={isModalOpen}
                closeModal={closeModal}
                id={parceiroId}
              />
            )}
          </div>
        </div>
        <FooterAdd />
      </form>
    </>
  );

  return <Menu screen={screenTela} />;
}

export default PartnersAdd;

{
  /*
        {isModalOpen && (
          <div className="my-modal-overlay">
            <div className="my-modal">
              <div className="my-modal-header">
                  <div className="my-modal-header-p1">
                    <h2>Procedimentos: TODOS</h2>
                    <input type="text" placeholder="Pesquisar" />
                  </div>
                  <div className="my-modal-header-p2">
                    <button type="button" onClick={closeModal} className="my-modal-button-close">X</button>
                  </div>
              </div>
              <section className="my-modal-body">
              <div className="my-modal-body-p1">
                <ul className="procedimentos-list">
                  <li className="procedimento-item">
                    <label className="procedimento-checkbox">
                      <input type="checkbox" id="procedimento-1" />
                      <span>Cod. 2323</span>
                      <span>Nome do Procedimento</span>
                    </label>

                    <div className="procedimento-pricing">
                      <input
                        type="number"
                        id="preco-custo-1"
                        placeholder="Preço de Custo R$"
                        aria-label="Preço de Custo"
                      />
                      <input
                        type="number"
                        id="preco-venda-1"
                        placeholder="Preço de Venda R$"
                        aria-label="Preço de Venda"
                      />
                      <button
                        type="button"
                        className="my-modal-button-delete"
                        aria-label="Excluir Procedimento"
                        disabled={true}
                      >
                        Excluir
                      </button>
                    </div>
                  </li>
                  <li className="procedimento-item">
                    <label className="procedimento-checkbox">
                      <input type="checkbox" id="procedimento-1" />
                      <span>Cod. 2323</span>
                      <span>Nome do Procedimento</span>
                    </label>

                    <div className="procedimento-pricing">
                      <input
                        type="number"
                        id="preco-custo-1"
                        placeholder="Preço de Custo R$"
                        aria-label="Preço de Custo"
                      />
                      <input
                        type="number"
                        id="preco-venda-1"
                        placeholder="Preço de Venda R$"
                        aria-label="Preço de Venda"
                      />
                      <button
                        type="button"
                        className="my-modal-button-delete"
                        aria-label="Excluir Procedimento"
                      >
                        Excluir
                      </button>
                    </div>
                  </li>
                  <li className="procedimento-item">
                    <label className="procedimento-checkbox">
                      <input type="checkbox" id="procedimento-1" />
                      <span>Cod. 2323</span>
                      <span>Nome do Procedimento</span>
                    </label>

                    <div className="procedimento-pricing">
                      <input
                        type="number"
                        id="preco-custo-1"
                        placeholder="Preço de Custo R$"
                        aria-label="Preço de Custo"
                      />
                      <input
                        type="number"
                        id="preco-venda-1"
                        placeholder="Preço de Venda R$"
                        aria-label="Preço de Venda"
                      />
                      <button
                        type="button"
                        className="my-modal-button-delete"
                        aria-label="Excluir Procedimento"
                      >
                        Excluir
                      </button>
                    </div>
                  </li>
                  <li className="procedimento-item">
                    <label className="procedimento-checkbox">
                      <input type="checkbox" id="procedimento-1" />
                      <span>Cod. 2323</span>
                      <span>Nome do Procedimento</span>
                    </label>

                    <div className="procedimento-pricing">
                      <input
                        type="number"
                        id="preco-custo-1"
                        placeholder="Preço de Custo R$"
                        aria-label="Preço de Custo"
                      />
                      <input
                        type="number"
                        id="preco-venda-1"
                        placeholder="Preço de Venda R$"
                        aria-label="Preço de Venda"
                      />
                      <button
                        type="button"
                        className="my-modal-button-delete"
                        aria-label="Excluir Procedimento"
                      >
                        Excluir
                      </button>
                    </div>
                  </li>
                  <li className="procedimento-item">
                    <label className="procedimento-checkbox">
                      <input type="checkbox" id="procedimento-1" />
                      <span>Cod. 2323</span>
                      <span>Nome do Procedimento</span>
                    </label>

                    <div className="procedimento-pricing">
                      <input
                        type="number"
                        id="preco-custo-1"
                        placeholder="Preço de Custo R$"
                        aria-label="Preço de Custo"
                      />
                      <input
                        type="number"
                        id="preco-venda-1"
                        placeholder="Preço de Venda R$"
                        aria-label="Preço de Venda"
                      />
                      <button
                        type="button"
                        className="my-modal-button-delete"
                        aria-label="Excluir Procedimento"
                      >
                        Excluir
                      </button>
                    </div>
                  </li>
                  <li className="procedimento-item">
                    <label className="procedimento-checkbox">
                      <input type="checkbox" id="procedimento-1" />
                      <span>Cod. 2323</span>
                      <span>Nome do Procedimento</span>
                    </label>

                    <div className="procedimento-pricing">
                      <input
                        type="number"
                        id="preco-custo-1"
                        placeholder="Preço de Custo R$"
                        aria-label="Preço de Custo"
                      />
                      <input
                        type="number"
                        id="preco-venda-1"
                        placeholder="Preço de Venda R$"
                        aria-label="Preço de Venda"
                      />
                      <button
                        type="button"
                        className="my-modal-button-delete"
                        aria-label="Excluir Procedimento"
                      >
                        Excluir
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
        </section>

            </div>
          </div>
        )} 
       */
}
